// extracted by mini-css-extract-plugin
module.exports = {"Style":"_2PIyjjgvzplb8sQ0zpFuOT"};